import { useState, useRef, useEffect, useCallback } from 'react';
import { PrimaryButton, SecondaryButton } from '../../buttons';
import api, { API_URL } from '../../../../api';
import { Flag01Icon, AlertDiamondIcon } from 'hugeicons-react';
import { showSuccess, showError } from '../../../../utils/notificationUtils';

const DeleteMeasureData = ({ measureId, isOpen, onClose, removeMeasure, measureName }) => {
    const synchronousId = typeof measureId === 'object' ? measureId.synchronousId : measureId;
    const actualId = typeof measureId === 'object' ? measureId.measureDataId : measureId;
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [measureDetails, setMeasureDetails] = useState(null);
    const popupRef = useRef(null);

    const fetchMeasureDetails = useCallback(async () => {
        try {
            console.log('Fetching details for synchronous_id:', synchronousId);
            const response = await api.get(`${API_URL}/measures/measure_data/${actualId}/`);
            setMeasureDetails(response.data);
            console.log('Measure details fetched:', response.data);
        } catch (error) {


        }
    }, [actualId, synchronousId]);

    useEffect(() => {
        if (isOpen && actualId) {
            fetchMeasureDetails();
        }
    }, [isOpen, actualId, fetchMeasureDetails]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        if (!actualId || actualId === undefined || actualId === null) {
            showError('Invalid synchronous_id. Cannot delete.', {}, 'delete');
            setIsSubmitting(false);
            return;
        }

        console.log('Attempting to delete measure with synchronous_id:', synchronousId);

        try {
            const response = await api.delete(`${API_URL}/measures/delete_measure_data_api/${actualId}/`);

            console.log('Delete response:', response);

            if (response.status === 200 || response.status === 204) {
                console.log('Measure deleted successfully, synchronous_id:', synchronousId);
if (removeMeasure) {
    await removeMeasure(actualId);
}

showSuccess(
    `Measure data (synchronous_id: ${synchronousId}) deleted successfully!`,
    { duration: 3000 },
    'delete'
);

onClose();
            }
        } catch (error) {
            console.error('Error deleting measure:', error.response ? error.response.data : error.message);
            console.error('Failed synchronous_id:', synchronousId);

            const errorMessage = error.response?.data?.message ||
                                error.response?.data?.error ||
                                'An error occurred while deleting the measure.';

            showError(
                `Failed to delete measure (synchronous_id: ${synchronousId}): ${errorMessage}`,
                {},
                'delete'
            );
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="overlay">
            <div className="popup-user" ref={popupRef}>
                <div className="delete-title">
                    <AlertDiamondIcon size={48} color='#D0021B'  />
                
                <div className="delete-confirmation">
                      <h4 className="title">Delete Measure Data</h4>
                    <p className="paragraph-red">
                        Do you want to delete this measure data <b>{measureName} </b>?
                    </p>
                    
                    <div className="measure-info">
                        {/* <p><strong>ID:</strong> {synchronousId}</p> */}
                        {measureDetails && (
                            <>
                                <p><strong>Measure:</strong> {measureDetails.measure || 'N/A'}</p>
                                <p><strong>Hospital:</strong> {measureDetails.hospital || 'N/A'}</p>
                                <p><strong>Value:</strong> {measureDetails.value || 'N/A'}</p>
                                <p><strong>Date:</strong> {measureDetails.starting_date || 'N/A'}</p>
                            </>
                        )}
                    </div>
                     </div>
                
                </div>

                <div className="buttons">
                    <SecondaryButton 
                        isLoading={false} 
                        onClick={onClose} 
                        buttonText={'Cancel'}
                        disabled={isSubmitting}
                    />
                    <PrimaryButton
                        isLoading={isSubmitting}
                        processingText={`Deleting synchronous_id ${synchronousId}...`}
                        buttonText='Delete'
                        onClick={handleSubmit}
                        disabled={!actualId}
                    />
                </div>
            </div>
        </div>
    );
};

export default DeleteMeasureData;
